import axios, { AxiosResponse } from 'axios';
import api from './api';

export interface ReviewDimension {
    id: number;
    name: string;
    description: string;
    created_by?: string | number;
    updated_by?: string | number;
    created_at?: string;
    updated_at?: string;
}

/**
 * Fetches all review dimensions
 */
export const getAllReviewDimensions = (): Promise<ReviewDimension[]> => {
    return api.get('/review_dimensions')
        .then(response => response.data);
};

/**
 * Creates a new review dimension
 */
export const createReviewDimension = (dimension: { name: string; description: string }): Promise<ReviewDimension> => {
    return api.post('/review_dimensions', dimension)
        .then(response => response.data);
};

/**
 * Updates an existing review dimension
 */
export const updateReviewDimension = (dimension: { name: string; description: string }): Promise<ReviewDimension> => {
    return api.put('/review_dimensions', dimension)
        .then(response => response.data);
};

/**
 * Deletes a review dimension by name
 */
export const deleteReviewDimension = (name: string): Promise<void> => {
    return api.delete(`/review_dimensions/${name}`)
        .then(response => response.data);
};
